module.exports = __webpack_public_path__ + "public/images/computer.f1dfefe714fe236c0fa1836c37593a62.png";